import React from 'react';

const CustomerStory = () => {
  return (
    <div className="py-16 sm:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Expert help. Whenever you need it.
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Our customers love our dedicated support team almost as much as our platform.
          </p>
        </div>
        
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-5">
            <div className="lg:col-span-2 relative">
              <img
                src="https://images.pexels.com/photos/3184405/pexels-photo-3184405.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                alt="Customer testimonial"
                className="h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent flex items-center justify-center">
                <div className="text-white p-8 lg:p-12">
                  <h3 className="text-2xl font-bold mb-2">Success Story</h3>
                  <p className="text-lg opacity-90">Global eCommerce brand</p>
                </div>
              </div>
            </div>
            
            <div className="lg:col-span-3 p-8 lg:p-12 flex flex-col justify-center">
              <div className="text-5xl text-blue-600 mb-6">"</div>
              <blockquote className="text-xl lg:text-2xl text-gray-800 mb-8 italic">
                We've tried others—but only CustMax made us feel like partners, not just users. The AI recommendations increased our email open rates by 38% in just two months.
              </blockquote>
              <div className="flex items-center">
                <div className="h-12 w-12 rounded-full bg-gray-300 overflow-hidden">
                  <img
                    src="https://images.pexels.com/photos/1181686/pexels-photo-1181686.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                    alt="Customer"
                    className="h-full w-full object-cover"
                  />
                </div>
                <div className="ml-4">
                  <h4 className="font-semibold text-gray-900">Sarah Chen</h4>
                  <p className="text-gray-600">Marketing Director, ShopGlobal</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerStory;